import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Tag from "../utils/Tag";
import { responseSelector } from '../utils/helpers/selectors';
import PYG from "../utils/PYG";

const { Text } = Inputs;



function PlanesList({ history, match }) {
  const dispatch = useDispatch();

  const modelPlanes = useSelector((state) => state.getPlanes);

  const [planes, setPlanes] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);



  useEffect(() => {

    const { data, error } = responseSelector(modelPlanes);

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      setPlanes(data.items);
      setTotalResults(data.total);

      dispatch(controller.duck.actions.clear());
    }
  }, [modelPlanes]);

  useEffect(() => {
    dispatch(controller.getPlanesThunk(match.params.localId, 1, pageSize));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setPlanes([]);
    dispatch(controller.getPlanesThunk(match.params.localId, page + 1, pageSize));
  }

  return (
    <Content
      title="Lista de planes"
      subTitle="Lista de planes"
      browserTitle="Lista de planes"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Lista de planes">
            <Col md="8"></Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() => history.push(`/crearPlan/${match.params.localId}`)}
                />
                <div>
                  <span>Total: {totalResults}</span>
                </div>
              </div>
            </Col>
            {planes && planes.length > 0 ? (
              <SimpleTable
              hover={true}
                data={planes.map((row, index) => {
                  let tipoDuracion = null;
                  if(row.subscriptions.tipoDuracion==='d'){
                    tipoDuracion = "Dias"
                  }
                  if(row.subscriptions.tipoDuracion==='w'){
                    tipoDuracion = "Semanas"
                  }
                  if(row.subscriptions.tipoDuracion==='m'){
                    tipoDuracion = "Meses"
                  }
                  return {
                    nombre: row.description,                    
                    precio: <PYG value={String(row.cost)} isNumericString={true} />,
                    tipoDuracion: tipoDuracion,
                    duracion: row.subscriptions.duration,
                    capacidad: row.subscriptions.capacidad,
                    estado: row.estado,
                    editar:(<Button
                      type="primary"
                      text="Editar"
                      onClick={() =>
                        history.push(`/editPlan/${row._id}/${match.params.localId}`)
                      }
                    />),
                  };
                })}
                columns={[
                  { title: "Nombre", data: "nombre" },
                  { title: "Precio", data: "precio" },
   
                  { title: "Duración", data: "duracion" },
                  { title: "Tipo de duración", data: "tipoDuracion" },
                  { title: "Sesiones disponibles", data: "capacidad" },
                  { title: "Estado", data: "estado" },
                  { title: "Editar", data: "editar" },
                ]}
              />
            ) : (
              <Col md="12">
                <h4>No se han encontrado resutlados</h4>
              </Col>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default PlanesList;
